export function removeAttributeWithOtherEntityName(attributes, allEntityNames, currentEntityName) {
    const newAttributes = attributes.filter((attribute) => {
        return !allEntityNames.some(name => {
            const nameRegex = new RegExp(name.toLowerCase())
            return (
                name !== currentEntityName &&
                attribute.name.toLowerCase().match(nameRegex)
            )
        })
    });
    return newAttributes;
}